var marketLocaleSeparator = '-';
export var uppercaseMarketRegion = function (marketLocale, separator) {
    if (separator === void 0) { separator = marketLocaleSeparator; }
    if (!marketLocale) {
        return '';
    }
    var _a = marketLocale.split(marketLocaleSeparator), _b = _a[0], language = _b === void 0 ? '' : _b, _c = _a[1], region = _c === void 0 ? '' : _c;
    return "" + language + separator + region.toUpperCase();
};
